import {
  Box,
  styled,
  Button,
} from "@mui/material";
import TextWrapper from "../../../../components/Text";

export const Wrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "-webkit-fill-available"
});


export const PhoneInputWrapper = styled(Box)({
  marginTop: 18,
  backgroundColor: "#fff",
  border: "1px solid #E6E8EC",
  borderRadius: 8,
  padding: 10,
  paddingLeft: 16,
  display: "flex",
  alignItems: "center",
  "& .react-tel-input": {
    width: "100%"
  },
  "& .form-control": {
    border: "none",
    borderLeft: "1px solid #E6E8EC",
    borderRadius: "unset",
    paddingLeft: 10,
    marginLeft: 10,
    fontWeight: 600,
    color: "#777E90",
    width: "inherit"
  },
  "& .flag-dropdown": {
    display: "none",
    backgroundColor: "unset",
    border: "none"
  },
  "& .emojiFlag": {
    borderRadius: 2
  },
});



export const SubcampaignInvalidTextWrapper = styled(TextWrapper)({
  textAlign: "center",
  display: "block",
  color: "#3572a6",
  fontSize: 16,
  padding: 5,
  lineHeight: 2,
  whiteSpace: "pre-line",
});
